import React from "react";
import { useState,useEffect } from "react";
import SalespersonSidebar from "./SalespersonSidebar";
import CkEditor from './CkEditor';
import { Helmet } from "react-helmet";
import './classes/EditBlog.css';
import './classes/DrupalEditForm.css';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
import Loading from './Loading';


const EditNewConferencePage =()=>{
 
    const initialFormData = {
        title:'',
        summary: '',
        body: '',
        field_bullet_points_editor:'',
        field_location:'',
        field_meta_title:'',
        field_meta_keywords:'',
        field_meta_description:'',
        field_sales_switch:'',
        field_early_bird_date:'',
        field_limitedseats:'',
        field_general_old_rate:'',
        field_student_old_rate:'',
        field_team_old_rate:'',
        field_prices_increase:'',
        field_speaker_title:'',
        field_speaker_description:'',
        field_new_general_sku:'',
        field_new_student_sku:'',
        field_new_team_sku:'',
        field_apply_form_desc:'',
        field_image:'',
        field_course_logo:'',
        field_delete_image:0,
        field_delete_course_logo:0,
        field_url_restriction:[],
        field_registration_deadline_day:'',
        field_registration_deadline_month:'',
        field_registration_deadline_year: 2018,
        field_conference_date:'',
        placements: [{ placement_page: '', placement_sort_order: '1' }],
        deleted_placements: [],
        url_alias: ''
    };
    const [formData,setFormData] =useState(initialFormData);
    const [isLoading, setIsLoading] = useState(true);
    const [toggle, setToggle] = useState(2);
    const [errors, setErrors] = useState({});
    const [tempImage, setTempImage] = useState(null);
    const [tempImageLogo, setTempImageLogo] = useState(null);
    const [imageUploadError, setImageUploadError] = useState('');
    const [imageUploadErrorLogo, setImageUploadErrorLogo] = useState('');
    const [selectedImage, setSelectedImage] = useState(null);
    const [uploadedImage, setUploadedImage] = useState(null);
    const [selectedLogoImage, setSelectedLogoImage] = useState(null);
    const [uploadedLogoImage, setUploadedLogoImage] = useState(null);
    const [showSummary, setShowSummary] = useState(false);
    const [editorMode, setEditorMode] = useState({
        body: true,
        bulletPoints: true,
    });
    const [savedData, setSavedData] = useState(initialFormData);
    const [PreviewFields, setPreviewFields] = useState(false);
    const [viewChanges, setViewChanges] = useState(false);
    const [originalData, setOriginalData] = useState(null);
    const [formDataSnapshot, setFormDataSnapshot] = useState(null);
    const [previewData, setPreviewData] = useState(null);
    const [detailedview, setDetailedView] = useState({});
    const [disabled, setDisabled] = useState(false);
    const [buttontext, setButtonText] = useState("Save");
    const [slug, setSlug] = useState("Save");
    const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);
    const [imageState, setImageState] = useState({
        image: {
            temp: null,
            selected: null,
            error: ''
        },
        logo: {
            temp: null,
            selected: null,
            error: ''
        }
    });
    
   const [pages, setPages] = useState([]);

    const months = [
        { value: "01", label: "Jan" },
        { value: "02", label: "Feb" },
        { value: "03", label: "Mar" },
        { value: "04", label: "Apr" },
        { value: "05", label: "May" },
        { value: "06", label: "Jun" },
        { value: "07", label: "Jul" },
        { value: "08", label: "Aug" },
        { value: "09", label: "Sep" },
        { value: "10", label: "Oct" },
        { value: "11", label: "Nov" },
        { value: "12", label: "Dec" }
    ];
    const days = Array.from({ length: 31 }, (_, i) => {
        const day = String(i + 1).padStart(2, "0");
        return { value: day, label: day };
    });
	
	  // From 2017 (the first conferences) to a few years ahead of today
	  const lastYear = Math.max(2029, new Date().getFullYear() + 5);
	  const years = Array.from(
        { length: lastYear - 2017 + 1 },
        (_, i) => {
            const year = String(2017 + i);
            return { value: year, label: year };
        }
    );

    const salesSwitch = [
        { value: "Registration Open", label: "Registration Open" },
        { value: "Be the first to know", label: "Be the first to know" },
        { value: "Free Registration Form", label: "Free Registration Form" },
    ];
    const loggedin_drupal_uid = localStorage.getItem('drupal_uid');
    const domainName = window.location.hostname;

    const location  = useLocation();
    const drupal_uid = localStorage.getItem('drupal_uid');
    
    const {tab} = useParams();
    const loggedin_uid = localStorage.getItem('uid');
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const domain_url = configData.DOMAIN_URL;
    
    const path = location.pathname.replace(/^\/+/, "");

    const [page, setPage] = useState(null);

    async function getplacementlist() {
        try {
            const response = await fetch(
                app_url+'node/getnodepages',
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setPages(responsedata.data.result);
            } 
        } catch (err) {
            
        } 
    }

       
    function updateToggle(id){
        setToggle(id);
        if(id == 1) { 
            window.location.href = "/" + page.url_slug;
        }
        if(id == 2) { 
            navigate("/"+page.url_source+"/edit");
        } 
    }

    const getPageTitle = () => {
        const title = originalData?.title || "";

        if (toggle === 1) {
            return title ? title : "Conference";
        } else if (toggle === 2) {
            return title ? `Edit Conference ${title}` : "Edit Conference";
        }

          return "Edit Conference"; 
    };

    const getPageHeading = () => {
        const title = originalData?.title || "";

        if (toggle === 2) {
            // As live's Drupal title: "<em>Edit Conference</em> title"
            return (
                <>
                    <em>Edit Conference</em> {title}
                </>
            );
        }

        return null;
    };

    useEffect(() => {
        Promise.all([
            getuserloggedinroles(), 
            getPageData(),
            getplacementlist(),
        ]).then(() => {
            setIsLoading(false);
        })
    } ,[]);

    async function getPageData() {
        try {
            setIsLoading(true);
            // The page as it is stored: the body keeps its $$...$$ placeholders
            const response = await fetch(
                app_url+'pages/getconferenceeditdata?path='+path,
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                // The form calls the stored body_summary "summary"
                const conference = {
                    ...responsedata.data,
                    summary: responsedata.data.body_summary || '',
                };
                setPage(conference);
                setFormData({
                    ...conference,
                    placements: (conference.placements || []).map(item => ({
                        ...item,
                        isExisting: true,
                    })),
                    deleted_placements: [],
                });
                setOriginalData({
                    ...conference,
                    placements: conference.placements || [],
                });
            }
        } catch (err) {
            
        }finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
        }
    }   

    async function getuserloggedinroles() {
        try {
            setIsLoading(true);
            const response = await fetch(
                app_url+'viewprofile/getuserloggedinrolesid',
                {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
               setUserLoggedInRoles(responsedata.data.roles);
            } 
        } catch (err) {
            
        }finally {
            setIsLoading(false); 
        }
    }      
      
    const cleanHtmlOutput = (html) => {
        if (!html) return '';

        let cleaned = html;

        cleaned = cleaned.replace(/<\s*(p|div|h[1-6])[^>]*>\s*(<br\s*\/?>|\&nbsp;|\s)*\s*<\/\1\s*>/gi, '');

        cleaned = cleaned.replace(/<br\s*\/?>/gi, '');

        const textOnly = cleaned.replace(/&nbsp;|\s|<[^>]*>/g, '').trim();

        return textOnly.length === 0 ? '' : html.trim();
    };
    const toggleEditor = (field) => {
        setEditorMode(prev => ({
            ...prev,
            [field]: !prev[field]
        }));
    };

    const onEditorChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value,
        }));
    };

  const urlRestriction = [
      {value: configData.RSMWW_DOMAIN, label: "SportsManagementWorldwide.com"},
      {value: configData.RSMWW_AGENCY_DOMAIN, label: "SMWWAgency.com"},
      {value: configData.RSMWW_SCOUT_DOMAIN, label: "SMWWScout.com"}
  ]

  const handleAddPlacement = () => {
      setFormData((prev) => ({
          ...prev,
          placements: [...prev.placements, { placement_page: '', placement_sort_order: '1', isExisting: false }],
      }));
  };

    const handleDeletePlacement = (index) => {
        setFormData((prev) => {
            const itemToDelete = prev.placements[index];
            const updatedDeleted = [...(prev.deleted_placements || [])];

            // Only placements that are already saved have to be removed on the server
            if (itemToDelete.isExisting && itemToDelete.placement_page) {
                updatedDeleted.push(itemToDelete.placement_page);
            }

            return {
                ...prev,
                placements: prev.placements.filter((_, i) => i !== index),
                deleted_placements: updatedDeleted,
            };
        });
    };

    const handlePlacementChange = (index, field, value) => {
        setFormData((prev) => {
            const updated = [...prev.placements];
            const changed = updated[index];
            const updatedDeleted = [...(prev.deleted_placements || [])];

            // A saved placement moved to another page: the page it was on is removed
            if (field === 'placement_page' && changed.isExisting && changed.placement_page) {
                updatedDeleted.push(changed.placement_page);
            }
            updated[index] = {
                ...changed,
                [field]: value,
                isExisting: field === 'placement_page' ? false : changed.isExisting,
            };

            return { ...prev, placements: updated, deleted_placements: updatedDeleted };
        });
    };
    const handlePreviewClick = () => {
        setViewChanges(false);
        const {
            title,
            summary,
            body,
            field_bullet_points_editor,
            field_apply_form_desc,
            field_image,
            field_registration_deadline_month,
            field_registration_deadline_day,
            field_registration_deadline_year,
            field_location,
            field_meta_title,
            field_meta_keywords,
            field_meta_description,
            field_sales_switch,
            field_early_bird_date,
            field_limitedseats,
            field_general_old_rate,
            field_student_old_rate,
            field_team_old_rate,
            field_prices_increase,
            field_speaker_title,
            field_speaker_description,
            field_new_general_sku,
            field_new_student_sku,
            field_new_team_sku,
            field_url_restriction,
            field_course_logo,
            field_conference_date,
        } = formData;

        const newErrors = {};
        if (!title?.trim()) {
            newErrors.title = "Title field is required.";
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setPreviewFields(false);
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
            return;
        }
        const bodyHtml = body || '';
        const finalBulletPoints = field_bullet_points_editor || '';
        const hasSummary = summary && summary.trim() !== '';
        let trimmedHtml = '';

        if (hasSummary) {
            trimmedHtml = summary;
        } else if (bodyHtml.includes('<!--break-->')) {
            trimmedHtml = bodyHtml.split('<!--break-->')[0];
        } else {
            const tmp = document.createElement('div');
            tmp.innerHTML = bodyHtml;
            const plainText = (tmp.textContent || tmp.innerText || "").trim();

            trimmedHtml = '';
        }

 

        setPreviewData({
            title,
            summary: hasSummary ? summary : '',
            trimmed: trimmedHtml,
            body: bodyHtml,
            field_image,
            field_course_logo,
            field_bullet_points_editor:finalBulletPoints,
            field_apply_form_desc,
            field_registration_deadline_month,
            field_registration_deadline_day,
            field_registration_deadline_year,
            field_location,
            field_meta_title,
            field_meta_keywords,
            field_meta_description,
            field_sales_switch,
            field_early_bird_date,
            field_limitedseats,
            field_general_old_rate,
            field_student_old_rate,
            field_team_old_rate,
            field_prices_increase,
            field_speaker_title,
            field_speaker_description,
            field_new_general_sku,
            field_new_student_sku,
            field_new_team_sku,
            field_conference_date,
            field_url_restriction: Array.isArray(field_url_restriction) &&
            field_url_restriction.length === 0
            ? ''
            : field_url_restriction,
        });
        window.scrollTo(0, 0);
        setErrors({});
        setPreviewFields(true);  
    };
    const handleViewChangesClick = () => {
        setPreviewFields(false);

        const newErrors = {};

        if (!formData.title?.trim()) {
            newErrors.title = "Title field is required.";
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            setViewChanges(false);

            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });

            return;
        }

        setViewChanges(true);

        setFormDataSnapshot({
            ...formData,
        });

        setOriginalData(prev => ({
            ...prev,
        }));

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    const normalizeArray = (arr = []) =>
        Array.isArray(arr) ? arr.join(', ') : '';
      
    const getFileIcon = (fileName) => {
        if (!fileName || typeof fileName !== 'string') {
            return '/images/image-x-generic.png';
        }
        const extension = fileName.split('.').pop().toLowerCase();

        switch (extension) {
            case 'txt':
            return '/basic/web/images/text-plain.png';
            case 'pdf':
            return '/basic/web/images/application-pdf.png';
            case 'docx':
            return '/basic/web/images/x-office-document.png';
            case 'jpg':
            case 'jpeg':
            return '/basic/web/images/image-x-generic.png';
            case 'xls':
            case 'xlsx':
            return '/basic/web/images/x-office-spreadsheet.png';
            case 'csv':
            return '/basic/web/images/text-x-generic.png';
            case 'mp4':
            return '/basic/web/images/video-x-generic.png';
            case 'png':
            return '/basic/web/images/image-x-generic.png';
            default:
            return '/basic/web/images/image-x-generic.png';
        }
    };

    const maxSize = 128 * 1024 * 1024;

    const getFileName = (value) => {
        if (!value) return "";
        if (typeof value === "string") {
          return value.split("/").pop(); // extract filename from URL
        }
        if (value.name) return value.name; // File object or wrapper with .name
        if (value.file && value.file.name) return value.file.name; // wrapper {file, preview, name}
        return "";
    };
    const getImageSrc = (value) => {
        if (!value) return "";
        if (typeof value === "string") return value;
        if (value.url) return value.url;

        if (value.preview) return value.preview;

        if (value.file instanceof File)
            return URL.createObjectURL(value.file);

        if (value instanceof File)
            return URL.createObjectURL(value);
        return "";
    };

    const getLabels = (values) => {
        if (!values || !Array.isArray(values)) return [];
        return values.map(val => {
            const option = urlRestriction.find(opt => opt.value === val);
            return option ? option.label : val; // Fallback to value if label not found
        });
    };

    const handleTempImageChange = (e, type) => {
        const file = e.target.files[0];
        if (!file) return;

        const validTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
        const maxSize = 128 * 1024 * 1024;

        // ---------- File type & size validation ----------
        if (!validTypes.includes(file.type)) {
            const errorHTML = `
                The selected file <em>${file.name}</em> cannot be uploaded.<br/>
                Only files with the following extensions are allowed:
                <em>png, gif, jpg, jpeg</em>.
            `;

            if (type === 'image') {
                setImageUploadError(errorHTML);
                setTempImage(null);
            } else {
                setImageUploadErrorLogo(errorHTML);
                setTempImageLogo(null);
            }

            e.target.value = '';
            return;
        }

        if (file.size > maxSize) {
            const errorHTML = `
                The selected file <em>${file.name}</em> cannot be uploaded.<br/>
                File must be less than <em>128 MB</em>.
            `;

            if (type === 'image') {
                setImageUploadError(errorHTML);
                setTempImage(null);
            } else {
                setImageUploadErrorLogo(errorHTML);
                setTempImageLogo(null);
            }

            e.target.value = '';
            return;
        }

        // ---------- Image dimension validation ----------
        const img = new Image();
        const objectUrl = URL.createObjectURL(file);

        img.onload = () => {
            const width = img.width;
            const height = img.height;
            let errorHTML = '';

            URL.revokeObjectURL(objectUrl);

            // ---------- Dimension error ----------
            if (errorHTML) {
                if (type === 'preview') {
                    setImageUploadError(errorHTML);
                    setTempImage(null);
                } else {
                    setImageUploadErrorLogo(errorHTML);
                    setTempImageLogo(null);
                }

                e.target.value = '';
                return;
            }

            // ---------- SUCCESS ----------
            if (type === 'image') {
                setImageUploadError('');
                setTempImage({ file });
            } else {
                setImageUploadErrorLogo('');
                setTempImageLogo({ file });
            }
        };

        img.onerror = () => {
            URL.revokeObjectURL(objectUrl);

            const errorHTML = `
                The selected file <em>${file.name}</em> cannot be uploaded.<br/>
                Invalid image file.
            `;

            if (type === 'image') {
                setImageUploadError(errorHTML);
                setTempImage(null);
            } else {
                setImageUploadErrorLogo(errorHTML);
                setTempImageLogo(null);
            }

            e.target.value = '';
        };

        img.src = objectUrl;
    };

    const handleImageUploadClick = (type) => {
        const alltempImage = type === 'image' ? tempImage : tempImageLogo;

        if (alltempImage?.file) {
            const objectUrl = URL.createObjectURL(alltempImage.file);

            if (type === 'image') {
                setSelectedImage({
                    file: alltempImage.file,
                    preview: objectUrl
                });

                setFormData(prev => ({
                    ...prev,
                    field_image: alltempImage.file,
                    field_delete_image: 0
                }));

                setImageUploadError('');
            } else {
                setSelectedLogoImage({
                    file: alltempImage.file,
                    preview: objectUrl
                });

                setFormData(prev => ({
                    ...prev,
                    field_course_logo: alltempImage.file,
                    field_delete_course_logo: 0
                }));

                setImageUploadErrorLogo('');
            }
        }
    };

    const handleRemoveSavedImage = (type) => {
        if (type === 'image') {
            setFormData(prev => ({
                ...prev,
                field_image: '',
                field_delete_image: 1
            }));
            setSelectedImage(null);
            setTempImage(null);
            setImageUploadError('');
        } else {
            setFormData(prev => ({
                ...prev,
                field_course_logo: '',
                field_delete_course_logo: 1
            }));
            setSelectedLogoImage(null);
            setTempImageLogo(null);
            setImageUploadErrorLogo('');
        }
    };

    const handleRemoveSelectedImage = (type) => {
        if (type === 'image') {
            setSelectedImage(null);
            setTempImage(null);
            setImageUploadError('');
            setFormData(prev => ({
                ...prev,
                field_image: '',
                field_delete_image: 0
            }));
        } else {
            setSelectedLogoImage(null);
            setTempImageLogo(null);
            setImageUploadErrorLogo('');
            setFormData(prev => ({
                ...prev,
                field_course_logo: '',
                field_delete_course_logo: 0
            }));
        }
    };

    const formatFileSize = (size) => {
        if (size < 1024) return size + " Bytes";
        else if (size < 1024 * 1024) return (size / 1024).toFixed(2) + " KB";
        else return (size / (1024 * 1024)).toFixed(2) + " MB";
    };
    const imageValue =
        selectedImage
            ? selectedImage.file
            : formData.field_image?.name;

    let imageFileName = '';

    if (imageValue instanceof File) {
        imageFileName = imageValue.name;
    } else if (typeof imageValue === 'string') {
        imageFileName = imageValue.split('/').pop();
    }
    const logoImageValue =
        selectedLogoImage
            ? selectedLogoImage.file
            : formData.field_course_logo?.name;

    let logoFileName = '';

    if (logoImageValue instanceof File) {
        logoFileName = logoImageValue.name;
    } else if (typeof logoImageValue === 'string') {
        logoFileName = logoImageValue.split('/').pop();
    }

    const handleChange = (e) => {
        const { name, type, value, checked } = e.target;

        if (type === 'checkbox') {
            setFormData((prev) => {
                const current = Array.isArray(prev[name]) ? prev[name] : [];

                return {
                    ...prev,
                    [name]: checked
                        ? [...current, value]
                        : current.filter((v) => v !== value),
                };
            });
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };
    
    const validateForm = () => {
        const newErrors = {};
        if (!formData.title.trim()) {
            newErrors.title = "Title is required.";
        }
        return newErrors;
    };

    // Drupal's red border on a field with an error (DrupalEditForm.css gives the normal border)
    const inputStyle = {
        title: errors.title ? { border: '2px solid red' } : {}
    };
 
    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = validateForm();

        setErrors(validationErrors);
        setViewChanges(false);
        setPreviewFields(false);
        setImageUploadError("");
        setImageUploadErrorLogo("");

        // If validation fails
        if (Object.keys(validationErrors).length > 0) {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
            return;
        }

        const finalBody = cleanHtmlOutput(formData.body);
        const finalBulletPoints = cleanHtmlOutput(formData.field_bullet_points_editor);

        setDisabled(true);
        setButtonText("Saving...");

        const postData = new FormData();
        const updatedFormData = {
            ...formData,
            body: finalBody,
            body_summary: formData.summary || '',
            field_bullet_points_editor:finalBulletPoints,
        };

        if (selectedImage?.file) {
            postData.append("field_image", selectedImage.file);
        }

        if (selectedLogoImage?.file) {
            postData.append("field_course_logo", selectedLogoImage.file);
        }

        postData.append("formData", JSON.stringify(updatedFormData));

        let saveError = "The conference page could not be saved.";
        try {
            const response = await fetch(app_url + "pages/updateconferencepage", {
                method: "POST",
                body: postData,
            });

            const data = await response.json();

            if (data.data && data.data.msg === "Success") {
                // The saved page, at the address it has now (the URL alias may have changed)
                window.location.href = "/" + data.data.url_slug;
                return;
            }
            saveError = (data.data && data.data.text) || data.message || saveError;
        } catch (err) {
            console.error(err);
        } finally {
            setDisabled(false);
            setButtonText("Save");
        }
        setErrors({ save: saveError });
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return(
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main" className={` ${toggle === 2 ? "edit-blog-main drupal-edit-page" : "smww-agency-news-content-main"}`}>
                    {!(userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) ? (
                        <p>You are not authorized</p>
                    ) : !page ? (
                        <p>The conference page could not be loaded.</p>
                    ) : <>
                    <Helmet>
                          <title>
                              {getPageTitle()}
                          </title>
                    </Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <>
                          <h1 className="edit-task-title">{getPageHeading()}</h1>
                        </>
                        <>
                            {(userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) &&
                                <ul className="tabs primarya">
                                    <li className= {toggle === 1? "active" : ""} onClick={()=> updateToggle(1)}>
                                        <a style={{cursor: "pointer"}}>View</a>
                                    </li>
                                  
                                    <li className= {toggle === 2? "active" : ""} onClick={()=> updateToggle(2)}>
                                        <a style={{cursor: "pointer"}}>Edit</a>
                                    </li>
                                </ul>
                            }
                        </>
                       
                        {(userLoggedInRoles.includes(configData.ROLE_SAADMIN) || userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR)) &&
                            <div  className= {toggle === 2? "show-content" : "content"}>
                                {viewChanges && (
                                    <div className='diff-table-wrapper'>
                                        <table className="diff-table">
                                            <colgroup>
                                                <col className="diff-marker" />
                                                <col className="diff-content" />
                                                <col className="diff-marker" />
                                                <col className="diff-content" />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th colSpan="2">Original</th>
                                                    <th colSpan="2">Changes</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {!formDataSnapshot || !originalData ? (
                                                    <tr className="no-changes">
                                                        <td className="diff-section-title" colSpan="4">No visible changes</td>
                                                    </tr>
                                                ) : (
                                                    (() => {
                                                        const diffs = [];

                                                        const compareField = (label, oldValue = '', newValue = '') => {
                                                            if (oldValue === newValue) return null;

                                                            const oldLines = (oldValue ?? '').split('\n');
                                                            const newLines = (newValue ?? '').split('\n');
                                                            const maxLines = Math.max(oldLines.length, newLines.length);

                                                            const rows = [
                                                                <tr className="diff-section-title" key={`${label}-title`}>
                                                                    <td colSpan="4">Changes to <em>{label}</em></td>
                                                                </tr>
                                                            ];

                                                            for (let i = 0; i < maxLines; i++) {
                                                                const oldLine = (oldLines[i] || '').trim();
                                                                const newLine = (newLines[i] || '').trim();

                                                                if (oldLine !== newLine) {
                                                                    const oldWords = oldLine.split(/\s+/);
                                                                    const newWords = newLine.split(/\s+/);
                                                                    const maxWords = Math.max(oldWords.length, newWords.length);

                                                                    const renderWords = (wordsA, wordsB, isOld) =>
                                                                    wordsA.map((word, idx) => {
                                                                        const matchingWord = wordsB[idx] || '';
                                                                        const changed = word !== matchingWord;

                                                                        return (
                                                                            <span
                                                                                key={`${label}-${isOld ? 'old' : 'new'}-${i}-${idx}`}
                                                                                style={changed ? {
                                                                                    color: isOld ? 'red' : 'red',
                                                                                    borderRadius: '4px',
                                                                                    padding: '0 3px',
                                                                                    fontWeight:'bold'
                                                                                } : {}}
                                                                            >
                                                                                {word}
                                                                                {' '}
                                                                            </span>
                                                                        );
                                                                    });

                                                                    rows.push(
                                                                        <tr key={`${label}-${i}`}>
                                                                            <td style={{width:"2px"}}><span>-</span></td>
                                                                            <td className="diff-removed">{renderWords(oldWords, newWords, true)}</td>
                                                                            <td style={{width:"2px"}}><span>+</span></td>
                                                                            <td className="diff-added">{renderWords(newWords, oldWords, false)}</td>
                                                                        </tr>
                                                                    );
                                                                }
                                                            }

                                                            return rows;
                                                        };

                                                        const compareFiles = (label, oldFiles = [], newFiles = []) => {
                                                            const oldList = Array.isArray(oldFiles)
                                                                ? oldFiles.map(f => f.name).join(', ')
                                                                : '';

                                                            const newList = Array.isArray(newFiles)
                                                                ? newFiles.map(f => f.name).join(', ')
                                                                : '';

                                                            // If no difference, return an empty array (safe + iterable)
                                                            if (oldList === newList) {
                                                                return [];
                                                            }
                                                            // Otherwise return whatever diff UI compareField creates
                                                            return [compareField(label, oldList, newList)];
                                                        };

                                                        diffs.push(...(compareField('Title', originalData.title, formDataSnapshot.title) || []));
                                                        diffs.push(...(compareField('Summary', originalData.summary, formDataSnapshot.summary) || []));
                                                        diffs.push(...(compareField('Body', originalData.body, formDataSnapshot.body) || []));

                                                        diffs.push(...(compareField(
                                                            'Form Description',
                                                            originalData.field_apply_form_desc,
                                                            formDataSnapshot.field_apply_form_desc
                                                        ) || []));

                                                        diffs.push(...(compareField(
                                                            'Meta Title',
                                                            originalData.field_meta_title,
                                                            formDataSnapshot.field_meta_title
                                                        ) || []));

                                                        diffs.push(...(compareField(
                                                            'Meta Keywords',
                                                            originalData.field_meta_keywords,
                                                            formDataSnapshot.field_meta_keywords
                                                        ) || []));

                                                        diffs.push(...(compareField(
                                                            'Meta Description',
                                                            originalData.field_meta_description,
                                                            formDataSnapshot.field_meta_description
                                                        ) || []));

                                                        diffs.push(...(compareField(
                                                            'Month',
                                                            originalData.field_registration_deadline_month,
                                                            formDataSnapshot.field_registration_deadline_month
                                                        ) || []));

                                                        diffs.push(...(compareField(
                                                            'Day',
                                                            originalData.field_registration_deadline_day,
                                                            formDataSnapshot.field_registration_deadline_day
                                                        ) || []));

                                                        diffs.push(...(compareField(
                                                            'Year',
                                                            originalData.field_registration_deadline_year,
                                                            formDataSnapshot.field_registration_deadline_year
                                                        ) || []));

                                                        diffs.push(...(compareField(
                                                            'Location',
                                                            originalData.field_location,
                                                            formDataSnapshot.field_location
                                                        ) || []));

                                                        diffs.push(...(compareField(
                                                            'Sales Switch',
                                                            originalData.field_sales_switch,
                                                            formDataSnapshot.field_sales_switch
                                                        ) || []));

                                                        diffs.push(...(compareField(
                                                            'Early Bird Date',
                                                            originalData.field_early_bird_date,
                                                            formDataSnapshot.field_early_bird_date
                                                        ) || []));

                                                        diffs.push(...(compareField(
                                                            'Limited Seats',
                                                            originalData.field_limitedseats,
                                                            formDataSnapshot.field_limitedseats
                                                        ) || []));

                                                        diffs.push(...(compareField(
                                                            'General Old Rate',
                                                            originalData.field_general_old_rate,
                                                            formDataSnapshot.field_general_old_rate
                                                        ) || []));

                                                        diffs.push(...(compareField(
                                                            'Student Old Rate',
                                                            originalData.field_student_old_rate,
                                                            formDataSnapshot.field_student_old_rate
                                                        ) || []));

                                                        diffs.push(...(compareField(
                                                            'Team Old Rate',
                                                            originalData.field_team_old_rate,
                                                            formDataSnapshot.field_team_old_rate
                                                        ) || []));

                                                        diffs.push(...(compareField(
                                                            'Prices Increase/Last Day Registration',
                                                            originalData.field_prices_increase,
                                                            formDataSnapshot.field_prices_increase
                                                        ) || []));

                                                        diffs.push(...(compareField(
                                                            'Bullet Points Editor',
                                                            originalData.field_bullet_points_editor,
                                                            formDataSnapshot.field_bullet_points_editor
                                                        ) || []));

                                                        diffs.push(...(compareField(
                                                            'Speakers Photos Main Title',
                                                            originalData.field_speaker_title,
                                                            formDataSnapshot.field_speaker_title
                                                        ) || []));

                                                        diffs.push(...(compareField(
                                                            'Speakers Photos Description',
                                                            originalData.field_speaker_description,
                                                            formDataSnapshot.field_speaker_description
                                                        ) || []));

                                                        diffs.push(...(compareField(
                                                            'New General SKU',
                                                            originalData.field_new_general_sku,
                                                            formDataSnapshot.field_new_general_sku
                                                        ) || []));

                                                        diffs.push(...(compareField(
                                                            'New Student SKU',
                                                            originalData.field_new_student_sku,
                                                            formDataSnapshot.field_new_student_sku
                                                        ) || []));

                                                        diffs.push(...(compareField(
                                                            'New Team SKU',
                                                            originalData.field_new_team_sku,
                                                            formDataSnapshot.field_new_team_sku
                                                        ) || []));

                                                        if (originalData.field_image !== formDataSnapshot.field_image) {
                                                            diffs.push(
                                                              <tr className="diff-section-title" key="preview-image-title">
                                                                  <td colSpan="4">Changes to <em>Avatar</em></td>
                                                              </tr>,
                                                              <tr key="preview-image-diff">
                                                                  <td><span>-</span></td>
                                                                  <td className="diff-removed">
                                                                    {originalData.field_image && getFileName(originalData.field_image)}
                                                                  </td>
                                                                  <td><span>+</span></td>
                                                                  <td className="diff-added" style={{ color: 'red', fontWeight: 'bold' }}>
                                                                      {formDataSnapshot.field_image && getFileName(formDataSnapshot.field_image)}
                                                                  </td>
                                                              </tr>
                                                          );
                                                      }
                                                      if (originalData.field_course_logo !== formDataSnapshot.field_course_logo) {
                                                          diffs.push(
                                                            <tr className="diff-section-title" key="banner-image-title">
                                                                <td colSpan="4">Changes to <em>Conference Logo</em></td>
                                                            </tr>,
                                                            <tr key="banner-image-diff">
                                                                <td><span>-</span></td>
                                                                <td className="diff-removed">
                                                                    {originalData.field_course_logo && getFileName(originalData.field_course_logo)}
                                                                </td>
                                                                <td><span>+</span></td>
                                                                <td className="diff-added" style={{ color: 'red', fontWeight: 'bold' }}>
                                                                    {formDataSnapshot.field_course_logo && getFileName(formDataSnapshot.field_course_logo)}
                                                                </td>
                                                            </tr>
                                                          );
                                                      }
                                                      diffs.push(
                                                          ...(compareField(
                                                              'URL Restriction',
                                                              normalizeArray(getLabels(originalData.field_url_restriction)),
                                                              normalizeArray(getLabels(formDataSnapshot.field_url_restriction))
                                                          ) || [])
                                                      );

                                                      return diffs.length > 0 ? diffs : (
                                                          <tr className="no-changes">
                                                              <td className="diff-section-title" colSpan="4">No visible changes</td>
                                                          </tr>
                                                      );
                                                    })()
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                                {PreviewFields && (
                                    <>
                                        <div
                                            className="messages status"
                                            style={{
                                                background: `#f0f8eb url("/basic/web/images/message-ok.png") no-repeat`,
                                                backgroundPosition: '10px 10px',
                                            }}
                                        >
                                            The trimmed version of your post shows what your post looks like when promoted
                                            to the main page or when exported for syndication.
                                            <span>
                                                You can insert the delimiter &lt;!--break--&gt; (without the quotes) to
                                                fine-tune where your post gets split.
                                            </span>
                                        </div>

                                        <div className="preview-container">
                                            {/* Trimmed version */}
                                            <div className="preview-trimmed">
                                                <h4 className="preview-heading">
                                                    <span className="preview-square"></span> Preview trimmed version
                                                </h4>

                                                <div className="email-teaser">
                                                    <h2 className="email-title">
                                                        <a href={"/content"}>{previewData?.title}</a>
                                                    </h2>

                                                    {(previewData.summary?.trim() || previewData.body?.includes('<!--break-->') || previewData.trimmed) && (
                                                        <div
                                                            className="preview-body-content"
                                                            dangerouslySetInnerHTML={{ __html: previewData.trimmed }}
                                                        />
                                                    )}

                                                    <div className="read-more-link">
                                                        <a href={"/"}>Read more</a>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Full version */}
                                            <div className="preview-full">
                                                <h4 className="preview-heading">
                                                    <span className="preview-square"></span> Preview full version
                                                </h4>

                                                <div className="email-teaser">
                                                    <h2 className="email-title">
                                                    </h2>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: previewData.body || '',
                                                        }}
                                                    />
                                                    <div className="email-meta">
                                                        {previewData.field_apply_form_desc && (
                                                            <p><strong>Form Description:</strong> {previewData.field_apply_form_desc}</p>
                                                        )}
                                                        {previewData.field_meta_title && (<p><strong>Meta Title:</strong> {previewData.field_meta_title}</p>)}
                                                        {previewData.field_meta_keywords && (
                                                        <p><strong>Meta Keywords:</strong> {previewData.field_meta_keywords}</p>)}
                                                        {previewData.field_meta_description && (
                                                        <p><strong>Meta Description:</strong> {previewData.field_meta_description}</p>)}

                                                        {/* Next Start Date Schedule */}
                                                        {(previewData.field_registration_deadline_month || previewData.field_registration_deadline_day) && (
                                                            <p>
                                                                <strong>Next Start Date: </strong> 
                                                                {previewData.field_registration_deadline_month || 'None'} - {previewData.field_registration_deadline_day || 'None'}
                                                            </p>
                                                        )}
                                                        {previewData.field_registration_deadline_year && (
                                                            <p><strong>Year:</strong> {previewData.field_registration_deadline_year}</p>
                                                        )}
                                                        {previewData.field_location && (
                                                            <p><strong>Location:</strong> {previewData.field_location}</p>
                                                        )}
                                                        {previewData.field_sales_switch && (
                                                            <p><strong>Sales switch:</strong> {previewData.field_sales_switch}</p> 
                                                        )} 
                                                        {previewData.field_early_bird_date && (
                                                            <p><strong>Early Bird Date:</strong> {previewData.field_early_bird_date}</p> 
                                                        )}
                                                        {previewData.field_limitedseats && (
                                                            <p><strong>Limited Seats:</strong> {previewData.field_limitedseats}</p> 
                                                        )}
                                                        {previewData.field_general_old_rate && (
                                                            <p><strong>General old rate:</strong> {previewData.field_general_old_rate}</p> 
                                                        )}
                                                        {previewData.field_student_old_rate && (
                                                            <p><strong>Student old rate:</strong> {previewData.field_student_old_rate}</p> 
                                                        )}
                                                        {previewData.field_team_old_rate && (
                                                            <p><strong>Team old rate:</strong> {previewData.field_team_old_rate}</p> 
                                                        )}
                                                        {previewData.field_prices_increase && (
                                                            <p><strong>Prices Increase/Last Day Registration:</strong> {previewData.field_prices_increase}</p> 
                                                        )}
                                                        {previewData.field_bullet_points_editor && (
                                                            <p><strong>Bullet Points Editor:</strong>   <div  dangerouslySetInnerHTML={{
                                                                __html: previewData.field_bullet_points_editor || '',
                                                            }}></div></p> 
                                                        )}
                                                        {previewData.field_speaker_title && (
                                                            <p><strong>Speakers Photos Main Title:</strong> {previewData.field_speaker_title}</p> 
                                                        )}
                                                        {previewData.field_speaker_description && (
                                                            <p><strong>Speakers Photos Description:</strong> {previewData.field_speaker_description}</p> 
                                                        )}
                                                        {previewData.field_new_general_sku && (
                                                            <p><strong>New General SKU:</strong> {previewData.field_new_general_sku}</p> 
                                                        )}
                                                        {previewData.field_new_student_sku && (
                                                            <p><strong>New Student Sku:</strong> {previewData.field_new_student_sku}</p> 
                                                        )}
                                                        {previewData.field_new_team_sku && (
                                                            <p><strong>New Team Sku:</strong> {previewData.field_new_team_sku}</p> 
                                                        )}
                                                        {previewData.field_image && (
                                                            <div>
                                                                <strong>Avatar:</strong><br />
                                                                <img 
                                                                    src={getImageSrc(previewData.field_image)} 
                                                                    alt="Preview" 
                                                                    style={{ maxHeight: "100px", maxWidth: "100px", marginTop: "5px" }} 
                                                                />
                                                            </div>
                                                        )}
                                                        {previewData.field_course_logo && (
                                                            <div>
                                                                <strong>Conference Logo:</strong><br />
                                                                <img 
                                                                    src={getImageSrc(previewData.field_course_logo)} 
                                                                    alt="Preview" 
                                                                    style={{ maxHeight: "100px", maxWidth: "100px", marginTop: "5px" }} 
                                                                />
                                                            </div>
                                                        )}

                                                        {previewData.field_url_restriction && (
                                                            <p>
                                                                <strong>URL Restriction:</strong>{" "}
                                                                {urlRestriction.filter(opt => previewData.field_url_restriction.includes(opt.value)).map(opt => opt.label).join(", ")}
                                                            </p>
                                                        )}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                                {/* drupal-edit-form: the fields as live's Drupal form shows them (DrupalEditForm.css) */}
                                <div className="edit-blog-container drupal-edit-form">
                                    {Object.values(errors).some(msg => !!msg) && (
                                        <div
                                            className="set-message-error error-message-padding"
                                            style={{
                                                background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                            }}
                                        >
                                            <ul>
                                              {Object.values(errors)
                                                  .filter(msg => !!msg)
                                                  .map((msg, index) => (
                                                    <li key={index}>{msg}</li>
                                              ))}
                                            </ul>
                                        </div>
                                    )}
                                    <form onSubmit={handleSubmit}>
                                        <div>
                                            <div className="form-item">
                                                <label htmlFor="create-agent-message-title">
                                                    Title{' '}
                                                    <span className="form-required" title="This field is required.*">*</span>
                                                </label>
                                                <input 
                                                    className="create-agent-message-title-field" 
                                                    type="text"
                                                    size={60}
                                                    id="create-agent-message-title" 
                                                    name="title" 
                                                    maxLength={100}
                                                    onChange={handleChange} 
                                                    value={formData.title}
                                                    style={inputStyle.title}
                                            
                                                />
                                            </div>
                                            <div className="form-item  fieldmeta-description">
                                                <label>Description for Apply Form </label>
                                                <textarea
                                                    name="field_apply_form_desc"
                                                    rows={5}
                                                    value={formData.field_apply_form_desc}
                                                    onChange={handleChange}
                                                />
                                                <div className="grippie" style={{
                                                    background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                                                }}>   
                                                </div>

                                            </div>
                                            <div>
                                                <div>
                                                    {showSummary && (
                                                        <div className="form-item">
                                                            <label htmlFor="create_summary">
                                                                Summary <span>(<a href="#" onClick={(e) => { e.preventDefault(); setShowSummary(false); }}>Hide summary</a>)</span>
                                                            </label>
                                                            <CkEditor
                                                                rows={5}
                                                                value={formData.summary}
                                                                onChange={html => setFormData(prev => ({ ...prev, summary: html }))}
                                                            />
                                                            <div className="description">Leave blank to use trimmed value of full text as the summary.</div>
                                                        </div>
                                                    )}

                                                    <div className="form-item">
                                                        <label htmlFor="create_body">
                                                            Body{' '}
                                                            {!showSummary && (
                                                                <span>
                                                                    (<a href="#" onClick={(e) => { e.preventDefault(); setShowSummary(true); }}>Edit summary</a>)
                                                                </span>
                                                            )}
                                                        </label>
                                                        <>
                                                            {editorMode.body ? (
                                                                <CkEditor
                                                                    rows={20}
                                                                    value={formData.body}
                                                                    onChange={html => onEditorChange('body', html)}
                                                                />
                                                            ) : (
                                                                <>
                                                                    <textarea
                                                                        className="new-conference-form-textarea"
                                                                        name="body"
                                                                        value={formData.body}
                                                                        onChange={e => onEditorChange('body', e.target.value)}
                                                                        rows={20}
                                                                    />
                                                                    <div
                                                                        className="grippie"
                                                                        style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}
                                                                    >
                                                                    </div>
                                                                </>
                                                            )}
                                                            <a href="#" onClick={(e) => { e.preventDefault(); toggleEditor('body'); }}>
                                                                Switch to {editorMode.body ? 'plain' : 'rich'} text editor
                                                            </a>
                                                        </>
                                                    </div>
                                                </div>
                                            </div>
                                                                                        
                                            <div>
                                                {imageUploadError && (
                                                    <div 
                                                        className="set-message-error error-message-padding"
                                                        style={{
                                                            background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                                        }}
                                                    >
                                                        <div 
                                                            style={{ color: '#8c2e0b',                                
                                                                backgroundColor: '#fef5f1',                                 
                                                                marginBottom: '10px', 
                                                                width: '80%',
                                                                borderRadius: '5px',
                                                                marginLeft:'30px'                                 
                                                            }}
                                                        dangerouslySetInnerHTML={{ __html: imageUploadError }}
                                                        >                            
                                                        </div>
                                                    </div>
                                                )}
                                                <div>
                                                    <label>Image</label>
                                                    {selectedImage ? (
                                                        // Case 1: New image selected
                                                        <>
                                                            <div className="edit-agent-image-container">
                                                                <img alt="Uploaded" src={selectedImage.preview} style={{marginBottom: "2px", maxWidth: "90px", maxHeight: "100px"}} />
                                                                <div className="image-info">
                                                                    <img
                                                                        className="file-icon"
                                                                        alt="File icon"
                                                                        src={getFileIcon(imageFileName)}
                                                                    />
                                                                    <a
                                                                        href={selectedImage.preview}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        className="image-name-link"
                                                                    >
                                                                        {imageFileName}
                                                                    </a>
                                                                    <span className="image-size">
                                                                        ({(selectedImage.file.size / 1024).toFixed(2)} KB)
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <input
                                                                type="button"
                                                                value="Remove"
                                                                className="form-submit"
                                                                onClick={() => handleRemoveSelectedImage('image')}
                                                            />
                                                        </>
                                                    ) : formData.field_image ? (
                                                        // Case 2: Image already saved (URL string from backend)
                                                        <>
                                                            <div className="edit-scout-report-image-container">
                                                                <img
                                                                    alt="Uploaded"
                                                                    src={formData.field_image?.url}
                                                                    style={{marginBottom: "2px", maxWidth: "90px", maxHeight: "100px"}}
                                                                />
                                                                <div className="image-info">
                                                                    <img
                                                                        className="file-icon"
                                                                        alt="File icon"
                                                                        src={getFileIcon(formData.field_image?.name)}
                                                                        width="16"
                                                                        height="16"
                                                                    />
                                                                    <a
                                                                        href={formData.field_image?.url}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        className="image-name-link"
                                                                    >
                                                                        {imageFileName}
                                                                    </a>
                                                                    <span className="image-size">
                                                                        {uploadedImage
                                                                            ? `(${(uploadedImage.size / 1024).toFixed(2)} KB)`
                                                                            : ""}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <input
                                                                type="button"
                                                                value="Remove"
                                                                className="form-submit"
                                                                onClick={() => handleRemoveSavedImage('image')}
                                                            />
                                                        </>
                                                    ) : (
                                                        // Case 3: No image yet → show upload input
                                                        <div>
                                                            <input
                                                                type="file"
                                                                id="edit-agent-photo-upload"
                                                                name="edit_agent_photo_upload"
                                                                accept="image/*"
                                                                onChange={(e) => handleTempImageChange(e, 'image')}
                                                            />
                                                            <input
                                                                type="button"
                                                                value="Upload"
                                                                className="form-submit"
                                                                onClick={() => handleImageUploadClick('image')}
                                                            />
                                                        </div>
                                                    )}

                                                    {!formData.field_image && !selectedImage && (
                                                        <div className="description" style={{fontSize:"12px"}}>
                                                            Files must be less than <b>128 MB</b>.<br />
                                                            Allowed file types: <b>png gif jpg jpeg</b>.
                                                        </div>
                                                    )}
                                                </div>
                                            </div>    
                                            <div style={{clear:"both"}}></div> 
                                            <div className="form-item">
                                                <label htmlFor="edit-field-call-back-month">Month </label>
                                                <div className="call-back-field">
                                                    <select
                                                        id="edit-field-call-back-month" 
                                                        name="field_registration_deadline_month"
                                                        value={formData.field_registration_deadline_month}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">-None-</option>
                                                        {months.map((m) => (
                                                            <option key={m.value} value={m.value}>
                                                            {m.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        
                                            <div className="form-item">
                                                <label htmlFor="edit-field-call-back-day">Day </label>
                                                <div className="call-back-field">
                                                <select 
                                                    className="" 
                                                    id="edit-field-call-back-day"
                                                    name="field_registration_deadline_day"
                                                    value={formData.field_registration_deadline_day}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">-None-</option>
                                                    {days.map((d) => (
                                                    <option key={d.value} value={d.value}>
                                                        {d.label}
                                                    </option>
                                                    ))}  
                                                </select>
                                                </div>
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-registration-deadline-year">Year </label>
                                                <select 
                                                    id="edit-field-registration-deadline-year"
                                                    name="field_registration_deadline_year"
                                                    value={formData.field_registration_deadline_year}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">- None -</option>
                                                    {years.map((y) => (
                                                        <option key={y.value} value={y.value}>
                                                        {y.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-location">Location</label>
                                                <input
                                                    className="new-conference-form-input"
                                                    type="text"
                                                    size={60}
                                                    id="edit-field-location"
                                                    name="field_location"
                                                    maxLength={60}
                                                    value={formData.field_location}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="form-item -field-meta-title">
                                                <label htmlFor="meta_title">Meta Title</label>
                                                <input type="text" id="meta_title" size={60} name="field_meta_title" value={formData.field_meta_title} onChange={handleChange} /> 
                                            </div>
                                            <div className="form-item field-meta-keywords">
                                                <label htmlFor="meta_keywords">Meta Keywords</label>
                                                <input type="text" id="meta_keywords" size={60} name="field_meta_keywords" value={formData.field_meta_keywords} onChange={handleChange} /> 
                                            </div>
                                            <div className="form-item  fieldmeta-description">
                                                <label>Meta Description</label>
                                                <textarea
                                                name="field_meta_description"
                                                rows={5}
                                                value={formData.field_meta_description}
                                                onChange={handleChange}
                                                />
                                                <div className="grippie" style={{
                                                    background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                                                }}></div>
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-sales-switch">Sales switch </label>
                                                <select 
                                                    id="edit-field-sales-switch"
                                                    name="field_sales_switch"
                                                    value={formData.field_sales_switch}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">- None -</option>
                                                    {salesSwitch.map((saleSwitch) => (
                                                    <option key={saleSwitch.value} value={saleSwitch.value}>
                                                        {saleSwitch.label}
                                                    </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-early-bird-date">Early Bird Date</label>
                                                <input
                                                    className="new-conference-form-input"
                                                    type="text"
                                                    size={60}
                                                    id="edit-field-early-bird-date"
                                                    name="field_early_bird_date"
                                                    maxLength={255}
                                                    value={formData.field_early_bird_date}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-limitedseats">Limited Seats</label>
                                                <input
                                                    className="new-conference-form-input"
                                                    type="text"
                                                    size={60}
                                                    id="edit-field-limitedseats"
                                                    name="field_limitedseats"
                                                    maxLength={255}
                                                    value={formData.field_limitedseats}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-general-old-rate">General old rate</label>
                                                <input
                                                    className="new-conference-form-input"
                                                    type="text"
                                                    size={60}
                                                    id="edit-field-general-old-rate"
                                                    name="field_general_old_rate"
                                                    maxLength={255}
                                                    value={formData.field_general_old_rate}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-student-old-rate">Student old rate</label>
                                                <input
                                                    className="new-conference-form-input"
                                                    type="text"
                                                    size={60}
                                                    id="edit-field-student-old-rate"
                                                    name="field_student_old_rate"
                                                    maxLength={255}
                                                    value={formData.field_student_old_rate}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-team-old-rate">Team old rate</label>
                                                <input
                                                    className="new-conference-form-input"
                                                    type="text"
                                                    size={60}
                                                    id="edit-field-team-old-rate"
                                                    name="field_team_old_rate"
                                                    maxLength={255}
                                                    value={formData.field_team_old_rate}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-prices-increase">Prices Increase/Last Day Registration</label>
                                                <input
                                                    className="new-conference-form-input"
                                                    type="text"
                                                    size={60}
                                                    id="edit-field-prices-increase"
                                                    name="field_prices_increase"
                                                    maxLength={255}
                                                    value={formData.field_prices_increase}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                                    
                                            <div className="form-item">
                                                <label>Bullet Points Editor</label>
                                                {editorMode.bulletPoints ? (
                                                    <CkEditor
                                                        rows={5}
                                                        value={formData.field_bullet_points_editor}
                                                        onChange={html => onEditorChange('field_bullet_points_editor', html)}
                                                    />
                                                ) : (
                                                    <>
                                                        <textarea  className="new-conference-form-textarea" value={formData.field_bullet_points_editor} onChange={e => onEditorChange('field_bullet_points_editor', e.target.value)} rows={5} />
                                                        <div className="grippie" style={{background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,}}></div>
                                                    </>
                                                )}
                                                <a href="#" onClick={(e) => { e.preventDefault(); toggleEditor('bulletPoints'); }}>
                                                    Switch to {editorMode.bulletPoints ? 'plain' : 'rich'} text editor
                                                </a>
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-speaker-title">Speakers Photos Main Title</label>
                                                <input
                                                    className="new-conference-form-input"
                                                    type="text"
                                                    size={60}
                                                    id="edit-field-speaker-title"
                                                    name="field_speaker_title"
                                                    maxLength={255}
                                                    value={formData.field_speaker_title}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-speaker-description">Speakers Photos Description</label>
                                                <input
                                                    className="new-conference-form-input"
                                                    type="text"
                                                    size={60}
                                                    id="edit-field-speaker-description"
                                                    name="field_speaker_description"
                                                    maxLength={255}
                                                    value={formData.field_speaker_description}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-new-general-sku">New General SKU</label>
                                                <input
                                                    className="new-conference-form-input"
                                                    type="text"
                                                    size={60}
                                                    id="edit-field-new-general-sku"
                                                    name="field_new_general_sku"
                                                    maxLength={255}
                                                    value={formData.field_new_general_sku}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-new-student-sku">New Student Sku</label>
                                                <input
                                                    className="new-conference-form-input"
                                                    type="text"
                                                    size={60}
                                                    id="edit-field-new-student-sku"
                                                    name="field_new_student_sku"
                                                    maxLength={255}
                                                    value={formData.field_new_student_sku}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-new-team-sku">New Team Sku</label>
                                                <input
                                                    className="new-conference-form-input"
                                                    type="text"
                                                    size={60}
                                                    id="edit-field-new-team-sku"
                                                    name="field_new_team_sku"
                                                    maxLength={255}
                                                    value={formData.field_new_team_sku}
                                                    onChange={handleChange}
                                                />
                                            </div>

                                            <div>
                                                <label>URL Restriction</label>
                                                <div>
                                                    {urlRestriction.map((url) => (
                                                        <label key={url.value} style={{ fontWeight: 'normal', lineHeight: '2' }}>
                                                            <input
                                                                type="checkbox"
                                                                name="field_url_restriction"
                                                                value={url.value}
                                                                checked={
                                                                    Array.isArray(formData.field_url_restriction) &&
                                                                    formData.field_url_restriction.includes(url.value)
                                                                }
                                                                onChange={handleChange}
                                                            />
                                                            {url.label}
                                                        </label>
                                                    ))}
                                                </div>
                                            </div>
                                            <div>
                                                {imageUploadErrorLogo && (
                                                    <div 
                                                        className="set-message-error error-message-padding"
                                                        style={{
                                                            background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                                        }}
                                                    >
                                                        <div 
                                                            style={{ color: '#8c2e0b',                                
                                                                backgroundColor: '#fef5f1',                                 
                                                                marginBottom: '10px', 
                                                                width: '80%',
                                                                borderRadius: '5px',
                                                                marginLeft:'30px'                                 
                                                            }}
                                                            dangerouslySetInnerHTML={{ __html: imageUploadErrorLogo }}
                                                        >                            
                                                        </div>
                                                    </div>
                                                )}
                                                <div>
                                                    <label>Conference Logo</label>
                                                    {selectedLogoImage ? (
                                                        // Case 1: New image selected
                                                        <>
                                                            <div className="edit-agent-image-container">
                                                                <img alt="Uploaded" src={selectedLogoImage.preview} style={{marginBottom: "2px", maxWidth: "90px", maxHeight: "100px"}} />
                                                                <div className="image-info">
                                                                    <img
                                                                        className="file-icon"
                                                                        alt="File icon"
                                                                        src={getFileIcon(logoFileName)}
                                                                    />
                                                                    <a
                                                                        href={selectedLogoImage.preview}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        className="image-name-link"
                                                                    >
                                                                        {logoFileName}
                                                                    </a>
                                                                    <span className="image-size">
                                                                        ({(selectedLogoImage.file.size / 1024).toFixed(2)} KB)
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <input
                                                                type="button"
                                                                value="Remove"
                                                                className="form-submit"
                                                                onClick={() => handleRemoveSelectedImage('logo')}
                                                            />
                                                        </>
                                                    ) : formData.field_course_logo? (
                                                        // Case 2: Image already saved (URL string from backend)
                                                        <>
                                                            <div className="edit-scout-report-image-container">
                                                                <img
                                                                    alt="Uploaded"
                                                                    src={formData.field_course_logo?.url}
                                                                    style={{marginBottom: "2px", maxWidth: "90px", maxHeight: "100px"}}
                                                                />
                                                                <div className="image-info">
                                                                    <img
                                                                        className="file-icon"
                                                                        alt="File icon"
                                                                        src={getFileIcon(formData.field_course_logo?.name)}
                                                                        width="16"
                                                                        height="16"
                                                                    />
                                                                    <a
                                                                        href={formData.field_course_logo?.url}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        className="image-name-link"
                                                                    >
                                                                        {logoFileName}
                                                                    </a>
                                                                    <span className="image-size">
                                                                        {uploadedLogoImage
                                                                            ? `(${(uploadedLogoImage.size / 1024).toFixed(2)} KB)`
                                                                            : ""}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <input
                                                                type="button"
                                                                value="Remove"
                                                                className="form-submit"
                                                                onClick={() => handleRemoveSavedImage('logo')}
                                                            />
                                                        </>
                                                    ) : (
                                                        // Case 3: No image yet → show upload input
                                                        <div>
                                                            <input
                                                                type="file"
                                                                id="edit-agent-photo-upload"
                                                                name="edit_agent_photo_upload"
                                                                accept="image/*"
                                                                onChange={(e) => handleTempImageChange(e, 'logo')}
                                                            />
                                                            <input
                                                                type="button"
                                                                value="Upload"
                                                                className="form-submit"
                                                                onClick={() => handleImageUploadClick('logo')}
                                                            />
                                                        </div>
                                                    )}

                                                    {!formData.field_course_logo && !selectedLogoImage && (
                                                        <div className="description" style={{fontSize:"12px"}}>
                                                        Files must be less than <b>128 MB</b>.<br />
                                                        Allowed file types: <b>png gif jpg jpeg</b>.
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div style={{clear:"both"}}></div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-conference-date">Conference Date</label>
                                                <input
                                                    className="new-conference-form-input"
                                                    type="text"
                                                    size={60}
                                                    id="edit-field-conference-date"
                                                    name="field_conference_date"
                                                    maxLength={255}
                                                    value={formData.field_conference_date}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <fieldset 
                                                className="form-wrapper" 
                                                style={{
                                                    border: "1px solid #ccc", 
                                                    padding: "15px 20px", 
                                                    marginBottom: "15px",
                                                    fontFamily: "sans-serif"
                                                }}
                                            >
                                            {/* Fieldset Legend Header */}

                                                <div className="editprofile-fieldset-wrapper">
                                                    <label>PLACEMENTS</label>
                                                    <table 
                                                        style={{
                                                            width: "100%",
                                                            borderCollapse: "collapse",
                                                            backgroundColor: "white",
                                                            border: "1px solid #ccc",
                                                            fontSize: "11px"
                                                        }} 
                                                        className="placements-table"
                                                    >
                                                        <thead>
                                                            <tr style={{ backgroundColor: "#e1e2dc", borderBottom: "1px solid #ccc" }}>
                                                                <th style={{ 
                                                                    width: '70%', 
                                                                    padding: '6px 10px', 
                                                                    textAlign: 'left', 
                                                                    fontWeight: 'bold', 
                                                                    color: '#333',
                                                                    textTransform: 'uppercase',
                                                                    borderRight: '1px solid #ccc'
                                                                }}>
                                                                    Page
                                                                </th>
                                                                <th style={{ 
                                                                    width: '15%', 
                                                                    padding: '6px 10px', 
                                                                    textAlign: 'left', 
                                                                    fontWeight: 'bold', 
                                                                    color: '#333',
                                                                    textTransform: 'uppercase',
                                                                    borderRight: '1px solid #ccc'
                                                                }}>
                                                                    Sort Order
                                                                </th>
                                                                <th style={{ 
                                                                    width: '15%', 
                                                                    padding: '6px 10px', 
                                                                    textAlign: 'center', 
                                                                    fontWeight: 'bold', 
                                                                    color: '#333',
                                                                    textTransform: 'uppercase'
                                                                }}>
                                                                    Delete
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {formData.placements.map((placement, index) => (
                                                                <tr key={index} style={{ borderBottom: index < formData.placements.length - 1 ? "1px solid #ccc" : "none" }}>
                                                                    {/* Page Select Column */}
                                                                    <td style={{ padding: '10px', borderRight: '1px solid #ccc' }}>
                                                                        <select
                                                                            className="placement-select"
                                                                            name={`placement_page_${index}`}
                                                                            value={placement.placement_page}
                                                                            onChange={(e) =>
                                                                                handlePlacementChange(index, 'placement_page', e.target.value)
                                                                            }
                                                                            style={{
                                                                                width: "100%",
                                                                                padding: "4px",
                                                                                border: "1px solid #ccc",
                                                                                borderRadius: "2px",
                                                                                fontSize: "12px",
                                                                                boxSizing: "border-box"
                                                                            }}
                                                                        >
                                                                            <option value="">Select a page</option>
                                                                            {pages.length > 0 && (
                                                                                <>
                                                                                    {pages.map((item) => (
                                                                                        <option key={item['id']} value={item['id']}>
                                                                                            {item['title']}
                                                                                        </option>
                                                                                    ))}
                                                                                </>
                                                                            )}
                                                                        </select>
                                                                    </td>

                                                                    {/* Sort Order Select Column */}
                                                                    <td style={{ padding: '10px', textAlign: 'center', borderRight: '1px solid #ccc' }}>
                                                                        <select
                                                                            name={`placement_sort_order_${index}`}
                                                                            className="adduser-form-select"
                                                                            value={placement.placement_sort_order}
                                                                            onChange={(e) =>
                                                                                handlePlacementChange(index, 'placement_sort_order', e.target.value)
                                                                            }
                                                                            style={{
                                                                                width: "100%",
                                                                                maxWidth: "60px",
                                                                                padding: "4px",
                                                                                border: "1px solid #ccc",
                                                                                borderRadius: "2px",
                                                                                fontSize: "12px"
                                                                            }}
                                                                        >
                                                                            {[...Array(50)].map((_, i) => (
                                                                                <option key={i + 1} value={i + 1}>
                                                                                    {i + 1}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    </td>

                                                                    {/* Delete Button Column */}
                                                                    <td style={{ padding: '10px', textAlign: 'center' }}>
                                                                        <button
                                                                            type="button"
                                                                            className='quick-links-reg-button form-submit'
                                                                            onClick={() => handleDeletePlacement(index)}
                                                                            
                                                                        >
                                                                            Delete
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>

                                                    {/* Add Placement Link */}
                                                    <div style={{ marginTop: "12px" }}>
                                                        <a
                                                            className="add-placement-link"
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                handleAddPlacement();
                                                            }}
                                                            style={{
                                                                color: "#0071B8",
                                                                textDecoration: "none",
                                                                fontWeight: "bold",
                                                                fontSize: "12px"
                                                            }}
                                                            onMouseOver={(e) => e.currentTarget.style.textDecoration = "underline"}
                                                            onMouseOut={(e) => e.currentTarget.style.textDecoration = "none"}
                                                        >
                                                            + Add
                                                        </a>
                                                    </div>
                                                </div>
                                            </fieldset>
                        
                                        
                                            <div className="form-item">
                                                <label htmlFor="edit-path-alias">
                                                    URL alias
                                                </label>
                                                <input
                                                    type="text"
                                                    size={60}
                                                    id="edit-path-alias" 
                                                    name="url_alias" 
                                                    onChange={handleChange} 
                                                    value={formData.url_alias}
                                                />
                                                <p className="description" style={{marginTop: "5px"}}>Optionally specify an alternative URL by which this content can be accessed. For example, type "about" when writing an about page. 
                                                Use a relative path and don't add a trailing slash or the URL alias won't work.</p>
                                            </div>       
                                    
                                            <div className="form-actions form-wrapper" id="create-actions">
                                                {/* <input type="submit" id="create-submit" name="" value="Save" className="form-submit" />&nbsp;&nbsp; */}
                                                <button type="submit" className="form-submit" disabled={disabled}>{buttontext}</button>&nbsp;&nbsp;
                                            <input 
                                                    type="button" 
                                                    id="edit-preview"  
                                                    value="Preview" 
                                                    className="form-submit" 
                                                    onClick={()=> {
                                                    handlePreviewClick();
                                                    // window.scrollTo({ top: 0, behavior: 'smooth' });
                                                    }}
                                                />&nbsp;&nbsp;
                                                <input
                                                    type="button"
                                                    id="edit-task-preview-changes"
                                                    value="View changes"
                                                    className="form-submit"
                                                    onClick={handleViewChangesClick}
                                                />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        }
                    </div>
                    </>}
                </div>
            )}
        </>
    );
};
export default EditNewConferencePage;